import { combineGuardsSerial } from '../../composer/combineGuardsSerial';
import { determineI18nResourceGuard } from '../../guards/determineI18nResourceGuard';
import { determineLanguageGuard } from '../../guards/determineLanguageGuard';
import { determineLnbCollapsedGuard } from '../../guards/status-board/determineLnbCollapsedGuard';
import { determineRegionEndpointGuard } from '../../guards/status-board/determineRegionEndpointGuard';

import type { AnyOfGuard } from '../../../types';

/**
 * Status 초기 진입 가드 체인 (전체 순차 실행)
 * @description
 * - determineLnbCollapsedGuard: LNB 접힘/펼침 상태 쿠키를 이용해 세팅
 * - determineRegionEndpointGuard: 리전·엔드포인트 메타
 * - determineLanguageGuard: 토큰 없을 시 쿠키 기반 언어 결정 (퍼블릭 서비스 대응)
 * - determineI18nResourceGuard: SSR용 i18n 리소스를 _nextI18Next props에 주입하여 hydration 불일치 방지
 */
const baseGuardArray: AnyOfGuard[] = [
  determineLnbCollapsedGuard,
  determineRegionEndpointGuard,
  determineLanguageGuard,
  determineI18nResourceGuard,
];

export const generateInitialServerSideGuards = (additionalGuards?: AnyOfGuard[]) => {
  const additions = additionalGuards ?? [];

  return combineGuardsSerial([...baseGuardArray, ...additions]);
};
